var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-card',[_c('edit-form',{ref:"editForm",attrs:{"disabled":_vm.isDisableEditForm,"billCartonTransferCode":this.params.code}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }